var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.checkBox
      ? _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                ref: "addrList",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.addrList, border: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    type: "selection",
                    selectable: _vm.selectable,
                    width: "55"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "150",
                    prop: "alias",
                    label: "地址别名",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "200",
                    prop: "regionName",
                    label: "地址信息",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(scope.row.regionName || "") +
                                _vm._s(scope.row.street || "")
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "是否默认",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm.addrFlag == true
                            ? _c(
                                "span",
                                [
                                  scope.row.defRevcFlag == true
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "danger" } },
                                        [_vm._v("默认")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c(
                                "span",
                                [
                                  scope.row.defSendFlag == true
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "danger" } },
                                        [_vm._v("默认")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.addrList,
                  border: "",
                  "highlight-current-row": ""
                },
                on: { "current-change": _vm.handleCurrentChange }
              },
              [
                _c("el-table-column", {
                  attrs: { width: "55" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "copy-radio",
                              class: {
                                circle:
                                  _vm.checlAddrInfo != null &&
                                  _vm.checlAddrInfo.id == rows.row.id
                              }
                            },
                            [_c("div", { staticClass: "circle-dot" })]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "150",
                    prop: "alias",
                    label: "地址别名",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "200",
                    prop: "regionName",
                    label: "地址信息",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(scope.row.regionName || "") +
                                _vm._s(scope.row.street || "")
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "是否默认",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm.addrFlag == true
                            ? _c(
                                "span",
                                [
                                  scope.row.defRevcFlag == true
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "danger" } },
                                        [_vm._v("默认")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c(
                                "span",
                                [
                                  scope.row.defSendFlag == true
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "danger" } },
                                        [_vm._v("默认")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-403aa637", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403aa637","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/RetailerAddrSelect.vue
// module id = 2057
// module chunks = 1